import { createSlice } from '@reduxjs/toolkit';

const exampleSlice = createSlice({
  name: 'example',
  initialState: {},
  reducers: {
    setExampleData(state, action) {
      state.data = action.payload;
    },
  },
});

export const { setExampleData } = exampleSlice.actions;
export default exampleSlice.reducer;
